export const APP_COLORS = {
  primary: '#13C2C2',
  secondary: 'rgba(19, 194, 194, 0.2)',
  error: '#ff0000',
  white: '#ffffff',
  baseColor: '#59A9F9',
  grayColor: '#CCCCCC'
}
